import React, { Component } from 'react';
import ReactToPrint from 'react-to-print';
import ComponentToPrintCard from '../ComponentToPrint/ComponentToPrintCard';
import { Button } from '@material-ui/core';

class PrintCard extends Component {
  render() {
    return (
      <div style={{ textAlign: 'center', paddingRight: "5px", paddingLeft: "5px" }}>
        <ReactToPrint
          trigger={() => (
            <Button
              variant="contained"
              size="small"
              style={{ backgroundColor: 'blue', color: 'white' }}
            >
              הדפסת כרטיס
            </Button>
          )}
          content={() => this.componentRef}
        />

        <div style={{ display: 'none' }}>
          <ComponentToPrintCard
            Person={this.props.Person}
            ref={(el) => (this.componentRef = el)}
          />
        </div>
      </div>
    );
  }
}

export default PrintCard;
